import { Enrollment } from "../../models/Enrollment";
import { Paged } from "../../models/Paged";
import { slavtHTTP } from "../http";

export function getEnrollments(page: number, size = 10) {
  return slavtHTTP
    .get<Paged<Enrollment>>(
      `/teachers/me/enrollments-students?page=${page}&size=${size}`,
    )
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}

export function updateEnrollment(
  enrollmentId: number,
  status: Enrollment["status"],
) {
  return slavtHTTP
    .patch<void>(`/enrollments/${enrollmentId}/status`, { status })
    .then(({ data }) => data)
    .catch((e) => {
      throw e;
    });
}
